define([
    "../../hereMapsModule",
    "text!./analysisMapViewHere.html"
], function (hereMapsModule, analysisMapViewHereTemplate) {
    "use strict";

    return hereMapsModule.directive("analysisMapViewHere", function () {
        return {
            restrict: "E",
            template: analysisMapViewHereTemplate,
            scope: {
                markers: "=?",
                routes: "=?",
                selectedMapMarkers: "=?",
                selectedMapRouteMarkers: "=?",
                onRegisterMarkersApi: "=?",
                onRegisterRoutesApi: "=?",
                carrierZoneGrouperToDraw: "@?",
                carrierZoneGrouperToDrawSpecifyBundleConfirm: "@?",
                refilterBaskets: "&",
            },
            controller: "analysisMapViewHereController"
        };
    });

});